define('bindings/knockout.page',["jquery", "knockout", "bindings/knockout.svgicon", "api", "i18n"], function ($, ko, svgicon, api, i18n) {
    var parseName = function (fullname) {
        var n = fullname.split('/');
        var directory = n[0];
        var filename = n.length > 1 ? n[1] : n[0];

        return {
            directory: directory,
            filename: filename
        };
    };
    
    var componentLoadingOperationUniqueId = 0;
    var pageCache = {};
    var allowCaching = function (pageUrl) {
        return [i18n.routes.vegboardRoot, i18n.routes.feedRoot, i18n.routes.placesRoot]
            .indexOf(pageUrl) >= 0;
    };
    
    var getFromCache = function (pageUrl) {
        var deferred = new $.Deferred();
        
        deferred.resolve(pageCache[pageUrl]);
        console.log(pageUrl + " resolved from cache");
        
        return deferred;
    };

    ko.bindingHandlers['page'] = {
        'init': function(element, valueAccessor, ignored1, ignored2, bindingContext) {
            var currentViewModel,
                currentLoadingOperationId,
                afterRenderSub,
                disposeAssociatedComponentViewModel = function () {
                    var currentViewModelDispose = currentViewModel && currentViewModel['dispose'];
                    if (typeof currentViewModelDispose === 'function') {
                        currentViewModelDispose.call(currentViewModel);
                    }
                    if (afterRenderSub) {
                        afterRenderSub.dispose();
                    }
                    afterRenderSub = null;
                    currentViewModel = null;
                    // Any in-flight loading operation is no longer relevant, so make sure we ignore its completion
                    currentLoadingOperationId = null;
                },
                originalChildNodes = ko.utils.makeArray(ko.virtualElements.childNodes(element));

            ko.utils.domNodeDisposal.addDisposeCallback(element, disposeAssociatedComponentViewModel);
            
            var applyViewModel = function(container, pageElement, oldPage, pageObject, loader, localPageLoadingIdx) {
                if (oldPage.length > 0) {
                    if(oldPage[0].vzPageViewModel)
                    {
                        if(typeof oldPage[0].vzPageViewModel.unload === "function" && oldPage[0].vzPageViewModel.vzViewModelStarted === true)
                            oldPage[0].vzPageViewModel.unload(bindingContext.$root);

                        delete bindingContext.$root[oldPage[0].vzPageViewModelName];
                        delete oldPage[0].vzPageViewModel;
                    }
                    
                    ko.removeNode(oldPage[0]);
                    // oldPage.remove();
                }

                if(localPageLoadingIdx != element.currentPageLoadingIdx)
                {
                    console.log("Before page viewmodel run: Page is not longer active, ignoring ...");
                    loader.remove();
                    return;
                }
                
                if(pageElement.vzViewModelReady && !pageElement.vzViewModelBound)
                {
                    pageElement.vzViewModelBound = true;
                    
                    if(pageElement.vzPageViewModel) {
                        bindingContext.$root[pageElement.vzPageViewModelName] = pageElement.vzPageViewModel;

                        if (typeof pageElement.vzPageViewModel.run === "function") {
                            pageElement.vzPageViewModel.run(bindingContext.$root);
                            pageElement.vzPageViewModel.vzViewModelStarted = true;
                        }
                    }
                    
                    window.setTimeout(function () {
                        console.log("EEE", localPageLoadingIdx, element.currentPageLoadingIdx);
                        
                        if(localPageLoadingIdx == element.currentPageLoadingIdx) {
                            ko.applyBindingsToDescendants(bindingContext, container);
                            loader.remove();
                            window.scrollTo(0,pageObject.scrollY || 0);
                            window.setTimeout(function () {
                                $(pageElement).css("visibility", "visible");
                            }, 0);
                        } else {
                            console.log("Page is not longer active, ignoring ...")
                            loader.remove();
                        }
                    }, 0);
                }
            };
            
            var baseUrl = api.getBaseUrl();
            element.currentPageLoadingIdx = 0;

            var extractPageFromServerResponse = function (pageResponse) {
                var pageHtml = new RegExp("<!-- PAGEBODY -->(.*)<!-- /PAGEBODY -->", "s").exec(pageResponse)[1]
                    .replace(/\/Content/g, "Content")
                    .replace(/"\/shared/g, "\"" + baseUrl + "/shared");
                return i18n.localizeTemplate(pageHtml);
            };

            ko.computed(function () {
                var value = ko.utils.unwrapObservable(valueAccessor());
                var currentPageViewModel = null;
                
                if(value) {
                    console.trace("page.load.start", value);
                    element.currentPageLoadingIdx++;
                    var localPageLoadingIdx = element.currentPageLoadingIdx; 
                    var svgUrl = "/Content/images/icons/common.svg";

                    if(window.cordova)
                        svgUrl = svgUrl.substr(1);
                    
                    var oldPage = $(element).find(".page-item");
                    oldPage.remove();
                    var oldLoader = $(element).find(".pcom-loader");
                    oldLoader.remove();
                    
                    var isLocalUrl = false;
                    
                    var pageUrl = value.url;
                    if(!navigator.onLine)
                    {
                        pageUrl = "/pages/offline";
                    }

                    var finalUrl = pageUrl;
                    if(pageUrl.indexOf("/pages/") === 0)
                    {
                        finalUrl = "~/Content" + pageUrl + ".html";
                    }
                    var xhr = allowCaching(finalUrl) && pageCache[finalUrl] ? getFromCache(finalUrl) : api.get(finalUrl);

                    var loader = $("<div class=\"pcom-loader\" style=\"position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;\"><div class=\"cssload-loader\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"currentColor\" d=\"M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z\" class=\"\"></path></svg></div>");
                    var skelet = $("<div class=\"page-skelet\"><div style=\"position: fixed; width: 100%; height: 100%;\"></div></div>");
                    var newPage = $("<div class=\"page-item\"></div>");
                    newPage.append(skelet);
                    $(element).append(newPage);
                    
                    if(xhr.state() !== "resolved") {
                        $(element).append(loader);
                    }
                    
                    xhr.done(function (result) {
                        if(allowCaching(finalUrl))
                            pageCache[finalUrl] = result;
                        
                        var pageViewModelNameMatch = new RegExp("data-vegzone-viewmodel=\"([^\"]+)\"").exec(result);
                        if(pageViewModelNameMatch) {
                            var pageViewModelName = pageViewModelNameMatch[1];
                            require(["app/" + pageViewModelName], function (viewmodel) {
                                if(typeof viewmodel === "function")
                                    viewmodel = new viewmodel();                                
                                
                                currentPageViewModel = viewmodel;

                                newPage.css("visibility", "hidden");
                                skelet[0].innerHTML = extractPageFromServerResponse(result);
                                $("html, body").scrollTop(0);
                                skelet.find("svg use").each(function () {
                                    svgicon.updateUse(this);
                                });                                
                                
                                newPage[0].vzPageViewModel = viewmodel;
                                newPage[0].vzPageViewModelName = pageViewModelName;
                                newPage[0].vzViewModelReady = true;
                                
                                applyViewModel(element, newPage[0], oldPage, value, loader, localPageLoadingIdx);
                            });
                        } else {
                            newPage.css("visibility", "hidden");
                            skelet[0].innerHTML = extractPageFromServerResponse(result);
                            $("html, body").scrollTop(0);
                            skelet.find("svg use").each(function () {
                                svgicon.updateUse(this);
                            });

                            newPage[0].vzViewModelReady = true;

                            applyViewModel(element, newPage[0], oldPage, value, loader, localPageLoadingIdx);
                        }
                    }).fail(function (error) {
                        var errorUrl = "~/Content/pages/error.html";
                        if(error === 404) errorUrl = "Content/pages/404.html";
                        if(error === 503) errorUrl = "_App_Offline.htm";

                        api.get(errorUrl).done(function (result) {
                            newPage.css("visibility", "hidden");
                            skelet[0].innerHTML = extractPageFromServerResponse(result);
                            $("html, body").scrollTop(0);
                            skelet.find("svg use").each(function () {
                                svgicon.updateUse(this);
                            });

                            newPage[0].vzViewModelReady = true;

                            applyViewModel(element, newPage[0], oldPage, value, loader, localPageLoadingIdx);                            
                        });
                    });
                } else {
                    ko.applyBindingsToDescendants(bindingContext, element);
                }
            }, null, { disposeWhenNodeIsRemoved: element });

            return { 'controlsDescendantBindings': true };
        }
    };

    ko.virtualElements.allowedBindings['page'] = true;
});

